/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Type_Picker_TitleInputs */

const en_case_type_picker_title = /** @type {(inputs: Case_Type_Picker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case type`)
};

const pt_br2_case_type_picker_title = /** @type {(inputs: Case_Type_Picker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de caso`)
};

/**
* | output |
* | --- |
* | "Case type" |
*
* @param {Case_Type_Picker_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_type_picker_title = /** @type {((inputs?: Case_Type_Picker_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Type_Picker_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_type_picker_title(inputs)
	return pt_br2_case_type_picker_title(inputs)
});